// removed by extract-text-webpack-plugin
module.exports = {"section":"section","custom-select":"custom-select"};


//////////////////
// WEBPACK FOOTER
// ./components/danangtrade-forms/_SubCategorySelectorInput.scss
// module id = ./components/danangtrade-forms/_SubCategorySelectorInput.scss
// module chunks = 0